import React, { FunctionComponent, ReactNode, RefObject, useRef, useState } from "react";
import { v1 as uuid } from "uuid";
import { useDrag, useDrop } from "react-dnd";
import "./style.scss";

interface Props {
  children: ReactNode;
  draggable: boolean;
  onDragEnd: (ref: RefObject<HTMLDivElement>) => void;
  onDragStart: (event: { ref: RefObject<HTMLDivElement>; pageX: number; pageY: number }) => void;
  onDrop?: () => void;
}

const Draggable: FunctionComponent<Props> = ({
  children,
  draggable,
  onDragEnd,
  onDragStart,
  onDrop,
}) => {
  const type = "draggable";
  const dragRef = useRef<HTMLDivElement>(null);
  const [elementId] = useState<string>(uuid());

  const [, drag] = useDrag({
    begin: (monitor) => {
      const itemPosition = monitor.getClientOffset();
      if (itemPosition === null || dragRef.current === null) {
        return;
      }

      setTimeout(
        () => onDragStart({ ref: dragRef, pageX: itemPosition.x, pageY: itemPosition.y }),
        0
      );
    },
    end: () => {
      onDragEnd(dragRef);
    },
    item: { type, id: elementId },
  });

  const [, drop] = useDrop({
    accept: type,
    drop: () => {
      if (onDrop) {
        onDrop();
      }
      onDragEnd(dragRef);
    },
  });

  if (draggable) {
    drag(drop(dragRef));
  } else {
    drop(dragRef);
  }

  return (
    <div className="Draggable" ref={dragRef}>
      {children}
    </div>
  );
};

export default Draggable;
